var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 36,
    viewBox: "0 0 28 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M26 31c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V17c0-1.654 1.346-3 3-3h18c1.654 0 3 1.346 3 3v14zM6 7c0-2.756 2.244-5 5-5h6c2.756 0 5 2.244 5 5v5H6V7zm18 5.102V7c0-3.86-3.14-7-7-7h-6C7.14 0 4 3.14 4 7v5.102c-2.28.464-4 2.484-4 4.898v14c0 2.756 2.244 5 5 5h18c2.756 0 5-2.244 5-5V17a5.006 5.006 0 00-4-4.898z"
  })));
}
SvgPadlock.displayName = 'Padlock';
export default SvgPadlock;